import { useState } from "react";
import { faqItems } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追漫小贴士"
          title="读者常见问题"
          desc="关于免费阅读、更新频率与使用方式，你关心的都在这里。"
        />

        <div className="flex flex-col gap-3">
          {faqItems.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl bg-background-50 transition-colors ${
                  open ? "ring-1 ring-primary-200" : ""
                }`}
              >
                <button
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <h3 className="font-medium text-foreground-900">{item.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-primary-600 transition-transform ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line text-lg" />
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}